import CallError from '../../utils/CallError';
import { isPlatinumApp } from '../../utils/apps';
import { shuffleArray } from '../../utils/general';
import { mapECItemToCardObject } from '../browse/search';
import { settings } from './setup';

/**
 * Home page featured apps based on cloud type
 * @param {object} params - an object of params
 * @param {('CC'|'EC'|'DC')} [params.cloud='EC'] - the cloud you want the featured apps for
 * @param {string} [params.authToken] - the auth token to use for the request
 */
export default async (params = {}, signal = null) => {
  const { cloud = 'EC', authToken } = params;
  const uppercasedCloud = cloud.toUpperCase();

  const headers = new Headers({
    'x-api-key': settings.apiKey,
    Accept: 'application/vnd.adobe.xt.app-card-v1+json',
  });

  if (authToken) {
    headers.append('Authorization', authToken);
  }

  const response = await fetch(`${settings.endpoint}/v2/apps?featured=true&type=${uppercasedCloud}`, {
    signal,
    headers,
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    let apps = content.cloudApps;
    if (uppercasedCloud === 'EC') {
      apps = shuffleArray(content.cloudApps.filter((app) => isPlatinumApp(app)).map(mapECItemToCardObject));
    } else {
      apps = shuffleArray(content.cloudApps);
    }
    return apps;
  }
};
